import PropTypes from 'prop-types';
export var stringOrNumberProp = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
export var alignContentProps = PropTypes.oneOf(['center', 'end', 'start', 'around', 'between', 'stretch']);
export var alignItemsProps = PropTypes.oneOf(['baseline', 'center', 'start', 'end', 'stretch']);
export var justifyContentProps = PropTypes.oneOf(['start', 'end', 'around', 'between', 'center']);
export var alignSelfProps = PropTypes.oneOf(['baseline', 'center', 'start', 'end', 'stretch']);
export var flexDirectionProps = PropTypes.oneOf(['column-reverse', 'column', 'row-reverse', 'row']);
export var flexWrapProps = PropTypes.oneOf(['nowrap', 'wrap-reverse', 'wrap']);
export var orderProps = PropTypes.oneOf([-1, 1, 0]);
export var array1To12Props = PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
export var array0To12Props = PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
export var columnProps = PropTypes.oneOfType([PropTypes.bool, // empty
array1To12Props, // 1-12
PropTypes.string]);